// some-field-required.validator.ts
import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export function someFieldRequired(ignore: string[] = []): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    if (!(formGroup instanceof FormGroup)) return null;

    const controls = formGroup.controls;
    const fields = Object.keys(controls).filter((key) => !ignore.includes(key));

    const hasValue = fields.some((f) => {
      const v = controls[f].value;
      return v !== null && v !== undefined && v !== '';
    });

    if (hasValue) {
      fields.forEach((f) => {
        const c = controls[f];
        if (c.hasError('some_field_required')) {
          const { some_field_required, ...rest } = c.errors || {};
          c.setErrors(Object.keys(rest).length ? rest : null);
        }
      });
      return null;
    }

    fields.forEach((f) => {
      const c = controls[f];
      const errs = c.errors || {};
      if (!errs['some_field_required']) {
        c.setErrors({ ...errs, some_field_required: true });
      }
    });

    return { some_field_required: true };
  };
}
